<template>
	<div class="order-item box-wrap">
		<div class="user-order">
			<div class="user-header">
				<img v-if="order.PayType == 1" class="order_icon" src="../assets/images/bankIcon.png" alt="">
				<img v-if="order.PayType == 2" class="order_icon" src="../assets/images/alipayIcon.png" alt="">
			</div>
			<div class="order-amount-time">
				<div class="order-amount"></div>
				<div class="order-time"><!--<span>交易 {{common.toDecimal2(order.Num)}}</span>&nbsp;·&nbsp;<span>好评 {{order.buyerScore}}%</span>--><br />
					<span v-if="order.OutTimestamp>0">剩余时间：{{restTime}}</span>
				</div>
			</div>
		</div>
		<div class="order-money-status">
			<div class="order-money">{{common.toDecimal2(order.CNY)}} CNY</div>
			<div class="order-status" @click="buy(order.OrderId)">购买</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'orderBuy',
		data(){
			return {
				defalutimg:_defaultimg_,
				restTime:'',
				timer: 0,
			nowTime: 0,
			nextTime: 0,
			coutTime: 0
			}
		},
		props:{
			order:{
				type:Object,
				default(){
					return 
				}
			},
			index:{
				type:Number ,                //值的类型
				required:true                //是否符合规定
			},
			searchForm: {
				type: Object,
				default() {
					return
				}
			}
		},
		methods:{
			goPage(){
				let name = 'orderbuyDetail',that=this;
				that.$store.commit('storeParams',{
		          	name:name,
		          	back:that.$store.state.routerStore.menu.active,
					orderId:that.order.OrderId,
					crtIndex:that.index,
					searchForm: that.searchForm  
		        })
				that.$router.push({name:name})
            },
            buy(orderId){//购买
                 let that=this;
               	 that.$message.confirm("提示","您确定要购买吗？",()=>{
					let data={"key":orderId};
                    that.$api.buy(data).then((res) => {
						that.goPage();
						// that.$emit('noticeParent',orderId);
                    });
		     });
            },
			countDownOrder(vue, differ) {
			vue.differ = differ
			this.timer = setInterval(function () {
				vue.restTime = vue.common.restTime(vue.differ)
				if (vue.differ <= 0) {
					clearInterval(this.timer)
					return false
				} else {
					vue.differ--
				}
			}, 1000)
			// !function run(vue){
			// }(vue)
		},
		},
		created(){
			this.countDownOrder(this, this.order.OutTimestamp)
		var that = this
		document.addEventListener('visibilitychange', function () {
			// console.log(document)
			if (document.visibilityState == 'visible') {
				that.nowTime = parseInt(new Date().getTime() / 1000)
				// console.log(that.nowTime)
				that.coutTime = parseInt(new Date(that.order.OutTime).getTime() / 1000)
				// console.log(that.coutTime - that.nowTime)
				var difftime = that.coutTime - that.nowTime
				if (difftime > 0) {
					that.countDownOrder(that, difftime)
				}
				// console.log('页面不可见');
			} else {
				// console.log(that.order.OutTime);
				if (that.timer) {
					clearInterval(that.timer)
				}
			}
		});;
		}
	}
</script>

<style lang="less" scoped>
	.order-item{
		display: flex;
		align-items: stretch;
		justify-content: space-between;
		.user-order{
            display: flex;
            .order-amount-time{
                    margin-top: 10px;
            }
		}
		.user-header{
			align-self:center;
			.header-wrap{
				width: 38px;
				height: 38px;
				margin-right: 16px;
				background: url(../assets/images/header.png) center center no-repeat;
				background-size: cover;
				border-radius:20px;
			}
		}
		.order-amount,
		.order-money{
            margin-top: -5px;
			margin-bottom: 10px;
			font-size:16px!important;
			color:#d9e3fd;
		}
		.order-time{
			color:#fefeff;
			span{
				display: inline-block;
				font-size: 12px!important;
				color:#96abe4;
			}
		}
		.order-money-status{
			display: flex;
			flex-direction:column;
			justify-content: space-between;
			text-align: right;
			.order-status{
                padding: 7px 10px;
                border-radius: 15px;
				font-size:12px!important;
                color:#d9e3fd;
                background-color: #00a0de;
				text-align: center;
				width: 48px;
    			margin-left: auto;
				&.timeout-status{
					color:#ef8299;
				}
				&.finish-status{
					color:#00a0de;
				}
			}
		}
		.order_icon{
			width: 38px;
			height: 38px;
			margin-right: 15px;
			border-radius: 50px;
		}
	}
</style>